import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import {
  Alert,
  Button,
  ErrorNotification,
  InfoFilledIcon,
} from '@mr-yum/frontend-ui'
import cn from 'classnames'
import { routes } from 'lib/routes'
import React, { ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface NotFoundProps {
  title?: ReactNode
  message?: ReactNode
  error?: Error | null
  clearError?: () => void
  className?: string
}

export const NotFound: React.FC<NotFoundProps> = ({
  title,
  message,
  error,
  clearError,
  className,
}) => {
  const intl = useIntl()
  return (
    <div
      className={cn(
        'flex h-screen w-screen flex-col items-center justify-center bg-surface-ui-background p-4 text-center text-foreground',
        className,
      )}
    >
      <div className="mb-8">
        <img
          src="/static/mryum_assets/toast.png"
          alt={intl.formatMessage({
            id: '37n4mf',
            defaultMessage: 'burnt toast',
          })}
          width={100}
        />
      </div>

      <h3 className="mb-8 my-heading-sm">
        {title || (
          <FormattedMessage
            defaultMessage="Bummer, we got nothin’. Please check the URL for typos."
            id="rqYGU5"
            description="When user tries to visit a page that does not exist, informal"
          />
        )}
      </h3>

      <div className="flex w-full max-w-[500px]">
        <div className="mr-2 flex-1">
          <RouteLink route={routes.home}>
            <Button as="a" fullWidth>
              <FormattedMessage defaultMessage="Go back" id="orvpWh" />
            </Button>
          </RouteLink>
        </div>

        {clearError && (
          <div className="mr-2 flex-1">
            <Button variant="outline" onClick={clearError} fullWidth>
              <FormattedMessage defaultMessage="Try again" id="FazwRl" />
            </Button>
          </div>
        )}
      </div>

      {message && (
        <div className="mt-14">
          <Alert icon={<InfoFilledIcon />} variant="info-subtle" fullWidth>
            {message}
          </Alert>
        </div>
      )}

      {error && (
        <div className="mt-14">
          <ErrorNotification fullWidth error={error} />
        </div>
      )}
    </div>
  )
}
